module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"type.simple":"Единственный выбор","type.multiple":"Множественный выбор","type.typed":"Набор пользователем","type.matchRadio":"Соответсвие с радиокнопками"}}')
  delete Component.options._Ctor
}
